import type { CreatableActivityWorkPath } from '@internal/spassu-code-contract';
import type { Activity, CreateActivityInput } from '../api/types';

export type PortalActivityWorkPath = CreatableActivityWorkPath;

export interface ActivityCreationJourney {
  workPath: PortalActivityWorkPath;
  title: string;
  description: string;
  prerequisites: readonly string[];
  consequence: string;
  requireTargetBranch: boolean;
  branchLabel: string;
  onCreated(activity: Activity): void;
}

export interface ActivityCreationGateway {
  create(input: CreateActivityInput): Promise<Activity>;
}

export interface ActivityCreationResult {
  activity: Activity;
  workPath: PortalActivityWorkPath;
}

export const CONTROL_PLANE_CREATION_COPY = {
  title: 'Control Plane',
  description: 'Fluxo para conectar um agente e executar o trabalho local.',
  prerequisites: [
    'Acesso ao repositório remoto selecionado.',
    'Branch base/destino do PR existente no repositório remoto.',
    'No Windows, use o Git Bash para executar os comandos do Control Plane.',
  ],
  consequence:
    'Na próxima tela, gere o pareamento para clonar o repositório em um workspace exclusivo e conectar o agente. O PR será aberto contra a branch escolhida e a via não poderá ser alterada depois da criação.',
} as const;
